import React from 'react';
import { ModalBody, Header, ModalContent, Title, CloseButton } from './styles';

/*
  ModalContainer is included around all modal components in order to have a
  consistent wrapper and consistent close-button behavior. Otherwise it will
  accept any arbitrary content via `props.children`
*/

const ModalContainer = ({
  closeModal,
  children,
  title,
  noHeader,
  dataCy,
  overflow,
  testId,
}: {
  closeModal: Function,
  children?: Object,
  title: string,
  dataCy?: string,
  overflow?: string,
  testId?: string,
}): React$Element<any> => {
  return (
    <ModalBody
      data-cy={dataCy}
      overflow={overflow}
      data-testid={`${testId}container`}
    >
      <Header noHeader={noHeader}>
        <Title>{title}</Title>
        <CloseButton
          data-testid={`${testId}close-button`}
          onClick={() => closeModal()}
          glyph="view-close"
        />
      </Header>

      <ModalContent>{children}</ModalContent>
    </ModalBody>
  );
};

export default ModalContainer;
